import React from "react";
import { Card, Container, Row, Col } from "react-bootstrap";
import RemoveShoppingCartIcon from "@material-ui/icons/RemoveShoppingCart";
import { Button } from "@material-ui/core";
import { useStateValue } from "../Stateprovider";

function Checkoutproduct({ id, image, projectTitle, description, price }) {
  const [{ basket }, dispatch] = useStateValue();

  const removeFromBasket = () => {
    dispatch({
      type: "REMOVE_FROM_BASKET",
      id: id,
    });
  };

  return (
    <div>
      <Card>
        <Card.Img variant="top" src={image} />
        <Card.Body>
          <Card.Title>{projectTitle}</Card.Title>
          <Card.Text>{description}</Card.Text>
          <small className="text-muted">${price}</small>
        </Card.Body>
        <Card.Footer>
          <Button
            color="primary"
            startIcon={<RemoveShoppingCartIcon />}
            onClick={removeFromBasket}
          >
            Remove from cart
          </Button>
        </Card.Footer>
      </Card>
    </div>
  );
}

export default Checkoutproduct;
